import CoverLetterImage from './assets/cover-letter-section-image.webp';

export const TITLE = 'Los geht’s mit dem Anschreiben';

export const TEXT_CONTENT =
  'Das Anschreiben markiert den Beginn Deiner Bewerbung. Es bietet die erste Gelegenheit, zu glänzen und <strong>einen bleibenden Eindruck</strong> zu hinterlassen. Diese Schlüsselpunkte solltest Du unbedingt beachten:';

export const BULLET_POINTS = [
  {
    headline: 'Spannende Einleitung',
    body: 'Fang die Aufmerksamkeit des Personalers sofort mit einem originellen Einstieg.',
  },
  {
    headline: 'Klare Botschaft',
    body: 'Wer bist Du, was kannst Du und warum passt Du perfekt? Kürze und Klarheit sind hier Deine besten Freunde.',
  },
  {
    headline: 'Keine Füllwörter',
    body: 'Komme schnell auf den Punkt und lasse leere Floskeln weg.',
  },
];

export const SECOND_TEXT_CONTENT =
  'Das Thema Anschreiben wird gerade sehr vielfältig diskutiert. Profitiert Deine Bewerbung davon, <strong>wenn ChatGPT das Anschreiben für Dich übernimmt?</strong> Was sind die Do’s and Dont’s beim Anschreiben und brauchen wir das Anschreiben perspektivisch überhaupt noch? Wenn Du tiefer in diese Themen eintauchen möchtest, dann empfehlen wir Dir folgende Artikel';

export const data = {
  image: CoverLetterImage,
  articleUrl:
    'https://www.xing.com/news/articles/von-wegen-08-15-so-trainierst-du-chatgpt-aussergewohnliche-anschreiben-zu-erstellen-5666660',
  thumbnail:
    'Von wegen 08/15! So trainierst Du ChatGPT, außergewöhnliche Anschreiben zu erstellen',
  readingTime: '8 minuten',
  section: 'cover-letter',
};
